import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14,
  _t15;
import { BOX_SHADOWS } from "../../constants/shadows";
import { fontSize, fontWeight, lineHeight } from "../../constants/typography";
import { BORDER_RADIUS } from "../../constants/borders";
import mediaQueries from "../../util/mediaqueries";
import { NeutralColors } from "../../constants/colors";
import styled from 'styled-components';
import { Picture } from "../images";
var testimonialWidth = {
  xs: 224,
  sm: 256,
  md: 320,
  lg: 352
};
export var TestimonialsContainer = styled.div.withConfig({
  componentId: "sc-is7o67-0"
})(["grid-column:1 / -1;margin-left:calc(50% - (", "px / 2));margin-bottom:16px;", ";", ";", ";"], testimonialWidth.xs, mediaQueries.sm(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-left: calc(50% - (", "px / 2));\n  "])), 0)), testimonialWidth.sm), mediaQueries.md(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-left: calc(50% - (", "px / 2));\n  "])), 0)), testimonialWidth.md), mediaQueries.lg(_t3 || (_t3 = _(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-left: calc(50% - (", "px / 2));\n  "])), 0)), testimonialWidth.lg));
export var BlockQuote = styled.blockquote.withConfig({
  componentId: "sc-is7o67-1"
})(["background-color:", ";border-radius:", ";box-shadow:", ",", ";cursor:", ";display:flex;flex-direction:column;height:100%;margin:0;padding:30px 20px;text-align:center;width:", "px;will-change:transform,opacity;transition:transform 0.4s ease-in,opacity 0.4s ease-in;opacity:", ";transform:scale(", ");", ";", ";", ";"], NeutralColors.White, BORDER_RADIUS.medium, BOX_SHADOWS.small, BOX_SHADOWS.medium, function (_ref) {
  var onClick = _ref.onClick;
  return onClick ? 'pointer' : 'default';
}, testimonialWidth.xs, function (_ref2) {
  var isCurrent = _ref2.isCurrent;
  return isCurrent ? 1 : 0.7;
}, function (_ref3) {
  var isCurrent = _ref3.isCurrent;
  return isCurrent ? 1.0001 : 0.9;
}, mediaQueries.sm(_t4 || (_t4 = _(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    padding: 36px 24px;\n    width: ", "px;\n  "])), 0)), testimonialWidth.sm), mediaQueries.md(_t5 || (_t5 = _(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    padding: 48px 32px;\n    width: ", "px;\n  "])), 0)), testimonialWidth.md), mediaQueries.lg(_t6 || (_t6 = _(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    width: ", "px;\n  "])), 0)), testimonialWidth.lg));
export var ReviewContainer = styled.div.withConfig({
  componentId: "sc-is7o67-2"
})(["align-items:center;display:flex;flex-grow:1;"]);
export var Review = styled.p.withConfig({
  componentId: "sc-is7o67-3"
})(["font-size:18px;font-weight:", ";line-height:", ";margin:0;", ";", ";&::before{content:'\u201C';}&::after{content:'\u201D';}"], fontWeight.regular, lineHeight.small, mediaQueries.sm(_t7 || (_t7 = _(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    font-size: ", ";\n  "])), 0)), fontSize.medium), mediaQueries.md(_t8 || (_t8 = _(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    font-size: ", ";\n  "])), 0)), fontSize.xLarge));
export var Cite = styled.cite.withConfig({
  componentId: "sc-is7o67-4"
})(["font-size:", ";font-style:normal;margin-top:15px;", ";", ";"], fontSize.x3Small, mediaQueries.sm(_t9 || (_t9 = _(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    margin-top: 18px;\n  "])), 0)), fontSize.x2Small), mediaQueries.md(_t10 || (_t10 = _(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    margin-top: 24px;\n  "])), 0)), fontSize.small));
export var Avatar = styled(Picture).withConfig({
  componentId: "sc-is7o67-5"
})(["border-radius:100%;box-shadow:", ";height:48px;vertical-align:middle;", ";", ";"], BOX_SHADOWS.small, mediaQueries.sm(_t11 || (_t11 = _(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    height: 56px;\n  "]))))), mediaQueries.md(_t12 || (_t12 = _(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    height: 72px;\n  "]))))));
export var Name = styled.p.withConfig({
  componentId: "sc-is7o67-6"
})(["margin:16px 0 0;"]);
export var JobTitle = styled.p.withConfig({
  componentId: "sc-is7o67-7"
})(["margin:2px 0 0;opacity:0.75;", ";"], mediaQueries.md(_t13 || (_t13 = _(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    margin-top: 4px;\n  "]))))));
export var Company = styled(Picture).withConfig({
  componentId: "sc-is7o67-8"
})(["height:24px;margin-top:15px;vertical-align:middle;", ";", ";"], mediaQueries.sm(_t14 || (_t14 = _(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    margin-top: 18px;\n  "]))))), mediaQueries.md(_t15 || (_t15 = _(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    height: 32px;\n    margin-top: 24px;\n  "]))))));